import { render, staticRenderFns } from "./analysis-filters-card.vue?vue&type=template&id=3964ab58&scoped=true"
import script from "./analysis-filters-card.vue?vue&type=script&lang=js"
export * from "./analysis-filters-card.vue?vue&type=script&lang=js"
import style0 from "./analysis-filters-card.vue?vue&type=style&index=0&id=3964ab58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964ab58",
  null
  
)

export default component.exports